import {Drawer, DrawerProps, ScrollArea} from '@mantine/core';
import {RecordForm} from "../forms/RecordForm.tsx";
import {PaymentProfile} from "../types.ts";

export const FormDrawer = (
    {
        record,
        handleSubmit,
        opened,
        onClose,
        ...rest
    }: DrawerProps & {
        record: PaymentProfile,
        handleSubmit: (values: PaymentProfile) => void
    }) => {

    const title = record?.id ? `Edit Payment Profile` : `Add Payment Profile`;

    const handleFormSubmit = async (values: PaymentProfile) => {
        const payload = {
            ...values,
            customerId: values.customerId || record.customerId
        };
        await handleSubmit(payload);
        onClose();
    };

    return (
        <Drawer
            transitionProps={{
                transition: "slide-up",
                duration: 750,
                timingFunction: "ease"
            }}
            position="right"
            offset={10}
            opened={opened}
            onClose={onClose}
            title={title}
            padding="xl"
            size="xl"
            scrollAreaComponent={ScrollArea.Autosize}
            {...rest}
        >
            <RecordForm
                record={record}
                handleSubmit={handleFormSubmit}
                handleCancel={onClose}
            />
        </Drawer>
    )
};